import { Message } from "element-ui"

/**
 * 读取文件
 * @param {*} file 
 * @returns 
 */
const readFile = (file) => {
    return new Promise((resolve) => {
        if (window.FileReader) {
            let reader = new FileReader()
            //将文件读取为二进制码
            reader.readAsBinaryString(file)
            reader.onload = (ev) => {
                resolve(ev.target.result)
            }
        } else {
            Message({
                message: '抱歉，您的浏览器，无法支持读取文件功能！',
                type: 'error'
            })
            resolve(null)
        }
    })
}

export {
    readFile
}